<template>
  <div class="canvas">
    <div class="biaoti">企业帮填表单详情页</div>
    <el-form :inline="true" class="demo-form-inline">
      <el-form-item label="访客名字">
        <el-input v-model="searchForm.name" placeholder="请输入访客名字"></el-input>
      </el-form-item>
      <el-form-item label="访客手机号">
        <el-input v-model="searchForm.phone" placeholder="请输入手机号"></el-input>
      </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="searchForm.zhuangTai" placeholder="全部">
          <el-option label="全部" value="全部"></el-option>
          <el-option label="未进入" value="未进入"></el-option>
          <el-option label="已进入" value="已进入"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item style="float: right;">
        <el-button type="primary" @click="search">查询</el-button>
        <el-button @click="reset">重置</el-button>
      </el-form-item>
    </el-form>

    <el-table :data="records" style="width: 100%">
      <el-table-column prop="name" label="访客名字" width="180"></el-table-column>
      <el-table-column prop="phone" label="访客手机号" width="180"></el-table-column>
      <el-table-column prop="fangkeQiyeName" label="来访单位" width="180"></el-table-column>
      <el-table-column prop="zhuangTai" label="拜访状态" width="180"></el-table-column>
      <el-table-column prop="readTime" label="到访时间" width="180"></el-table-column>
      <el-table-column label="操作" width="180">
        <template #default="scope">
          <el-button type="text" @click="viewDetails(scope.row)">查看详情</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      background
      layout="prev, pager, next"
      :total="totalRecords"
      :page-size="pageSize"
      @current-change="handlePageChange">
    </el-pagination>

    <!-- 审批管理抽屉 -->
    <el-drawer title="审批管理" :visible.sync="drawerVisible" direction="rtl" size="50%">
      <div v-if="!approveDialogVisibleInDrawer">
        <el-form label-width="120px" label-position="left">
          <el-form-item label="访客名字" style="padding-left: 20px"><el-input v-model="currentRecord.name" disabled /></el-form-item>
          <el-form-item label="访客手机号" style="padding-left: 20px"><el-input v-model="currentRecord.phone" disabled /></el-form-item>
          <el-form-item label="来访单位" style="padding-left: 20px"><el-input v-model="currentRecord.fangkeQiyeName" disabled /></el-form-item>
          <el-form-item label="接访人名字" style="padding-left: 20px"><el-input v-model="currentRecord.jieFangRenName" disabled /></el-form-item>
          <el-form-item label="接访人手机号" style="padding-left: 20px"><el-input v-model="currentRecord.jieFangRenPhone" disabled /></el-form-item>
          <el-form-item label="填写时间" style="padding-left: 20px"><el-input v-model="currentRecord.writeTime" disabled /></el-form-item>
          <el-form-item label="到访时间" style="padding-left: 20px"><el-input v-model="currentRecord.readTime" disabled /></el-form-item>
          <el-form-item label="到访原因" style="padding-left: 20px"><el-input v-model="currentRecord.reason" disabled /></el-form-item>
          <el-form-item label="到访人数" style="padding-left: 20px"><el-input v-model="currentRecord.daofangNumber" disabled /></el-form-item>
          <el-form-item label="访客二维码" style="padding-left: 20px">
            <div class="qr-code">
              <img v-if="currentRecord.qrCode" :src="'data:image/png;base64,' + currentRecord.qrCode" />
            </div>
          </el-form-item>
          <el-form-item label="访客数字码" style="padding-left: 20px"><el-input v-model="currentRecord.fangkeNumber" disabled /></el-form-item>
          <el-form-item label="状态" style="padding-left: 20px"><el-input v-model="currentRecord.zhuangTai" disabled /></el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" v-if="currentRecord.zhuangTai === '未审批' && currentRecord.shenpi===2" @click="approve" class="footer-right">点击进行审批</el-button>
          <el-button @click="drawerVisible = false" class="footer-right">关闭</el-button>
        </span>
      </div>
      <div v-else>
        <el-form>
          <el-form-item>
            <el-button type="primary" @click="approveRecord('通过')" style="padding-left: 20px">审批通过</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="warning" @click="approveRecord('不通过')" style="padding-left: 20px">审批不通过</el-button>
          </el-form-item>
          <el-form-item label="不通过原因">
            <el-input v-model="rejectReason" placeholder="请输入"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="approveDialogVisibleInDrawer = false" >取消</el-button>
        </span>
      </div>
    </el-drawer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      searchForm: { name: '', phone: '', zhuangTai: '全部' },
      records: [],
      totalRecords: 0,
      pageSize: 10,
      currentPage: 0,
      drawerVisible: false,
      approveDialogVisibleInDrawer: false,
      currentRecord: {},
      rejectReason: ''
    };
  },
  methods: {
    search() {
      this.currentPage = 0;
      this.fetchRecords();
    },
    fetchRecords() {
      const params = {
        name: this.searchForm.name || undefined,
        phone: this.searchForm.phone || undefined,
        zhuangTai: this.searchForm.zhuangTai === '全部' ? undefined : this.searchForm.zhuangTai,
        page: this.currentPage * this.pageSize,
        size: this.pageSize
      };
      Object.keys(params).forEach(key => { if (params[key] === undefined) delete params[key]; });
      this.$axios.get('/api/chaxun_qiye_form_zhuo', { params }).then(res => {
        this.records = res.data.data;
        this.records.forEach(item => {
          if (item.readTime) item.readTime = item.readTime.replace('T', ' ');
        });
      });
    },
    reset() {
      Object.assign(this.searchForm, { name: '', phone: '', zhuangTai: '全部' });
      this.records = [];
      this.totalRecords = 0;
      this.currentPage = 0;
      this.fetchRecords();
    },
    viewDetails(row) {
      this.currentRecord = Object.assign({}, row);
      this.drawerVisible = true;
    },
    handlePageChange(page) {
      this.currentPage = page - 1;
      this.fetchRecords();
    },
    approve() {
      this.approveDialogVisibleInDrawer = true;
    },
    approveRecord(status) {
      if (status === '不通过' && !this.rejectReason.trim()) {
        this.$message.error('请输入不通过原因');
        return;
      }
      const approvalData = {
        id: this.currentRecord.id,
        status,
        errReason: status === '不通过' ? this.rejectReason : ''
      };
      if (status === '通过') {
        const id = this.currentRecord.id
        this.$axios.post('/api/qiye_form/change0_zhuo', 
          id
          ).then(() => {
          this.$message.success('审批通过');
          this.fetchRecords();
        });
      } else {
        this.$axios.post('/api/qiye_form/change1_zhuo', approvalData).then(() => {
          this.$message.success('审批不通过');
          this.fetchRecords();
        });
      }
      this.approveDialogVisibleInDrawer = false;
      this.drawerVisible = false;
    }
  },
  mounted() {
    this.fetchRecords();
  }
};
</script>

<style>
.canvas {
  background-color: white;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  width: 97%;
  position: relative;
}
.biaoti {
  font-family: 'Georgia', serif;
  color: #4396e5;
  font-size: 30px;
  font-weight: bold;
  padding: 15px;
}
.dialog-footer {
  display: flex;
  justify-content: flex-end;
  margin-right: 20px;
}
.footer-right {
  margin-left: 10px;
}
</style>
